type FrameDot = [number, number]
type Frame = FrameDot[]
type Frames = Frame[]

// "Analyzing" - A scanning cross-pattern that moves diagonally across the grid
const analyzingFrames: Frames = [
    [[0, 0], [1, 1], [2, 2], [3, 3], [4, 4]],
    [[1, 0], [2, 1], [3, 2], [4, 3]],
    [[2, 0], [3, 1], [4, 2], [0, 3], [1, 4]],
    [[3, 0], [4, 1], [0, 2], [1, 3], [2, 4]],
    [[4, 0], [0, 1], [1, 2], [2, 3], [3, 4]],
    [[0, 0], [1, 1], [2, 2], [3, 3], [4, 4]],
    [[0, 4], [1, 3], [2, 2], [3, 1], [4, 0]],
    [],
]

// "Learning" - Neural network firing from center outward, then collecting back
const learningFrames: Frames = [
    [[2, 2]],
    [[1, 2], [2, 1], [2, 3], [3, 2]],
    [[0, 2], [1, 1], [1, 3], [2, 0], [2, 4], [3, 1], [3, 3], [4, 2]],
    [[0, 0], [0, 4], [4, 0], [4, 4], [0, 1], [0, 3], [1, 0], [1, 4], [3, 0], [3, 4], [4, 1], [4, 3]],
    [[0, 0], [0, 4], [4, 0], [4, 4]],
    [[1, 1], [1, 3], [3, 1], [3, 3]],
    [[2, 2]],
    [],
]

// "Optimizing" - Orbital rotation around edges (clockwise)
const optimizingFrames: Frames = [
    [[0, 0], [1, 0], [2, 0]],
    [[3, 0], [4, 0], [4, 1]],
    [[4, 2], [4, 3], [4, 4]],
    [[3, 4], [2, 4], [1, 4]],
    [[0, 4], [0, 3], [0, 2]],
    [[0, 1], [0, 0], [1, 0]],
    [[2, 0], [3, 0], [4, 0]],
    [[4, 1], [4, 2], [4, 3]],
]

// "Targeting" - Corners converge to center, then pulse outward
const targetingFrames: Frames = [
    [[0, 0], [4, 0], [0, 4], [4, 4]],
    [[1, 1], [3, 1], [1, 3], [3, 3]],
    [[2, 2]],
    [[1, 1], [1, 2], [1, 3], [2, 1], [2, 3], [3, 1], [3, 2], [3, 3]],
    [[0, 0], [0, 2], [0, 4], [2, 0], [2, 4], [4, 0], [4, 2], [4, 4]],
    [[1, 1], [3, 1], [1, 3], [3, 3]],
    [[0, 0], [4, 0], [0, 4], [4, 4]],
    [],
]

// "Engaging" - Rhythmic pulse/heartbeat expanding wave
const engagingFrames: Frames = [
    [[2, 2]],
    [[1, 2], [2, 1], [2, 3], [3, 2], [2, 2]],
    [[0, 2], [1, 1], [1, 3], [2, 0], [2, 4], [3, 1], [3, 3], [4, 2]],
    [[1, 2], [2, 1], [2, 3], [3, 2], [2, 2]],
    [[2, 2]],
    [[1, 2], [2, 1], [2, 3], [3, 2], [2, 2]],
    [[0, 1], [0, 3], [1, 0], [1, 4], [3, 0], [3, 4], [4, 1], [4, 3], [2, 2]],
    [[1, 2], [2, 1], [2, 3], [3, 2], [2, 2]],
    [[2, 2]],
    [],
]

export const AI_TRAINING_STATES = {
    analyzing: { frames: analyzingFrames, label: "Analyzing" },
    learning: { frames: learningFrames, label: "Learning" },
    optimizing: { frames: optimizingFrames, label: "Optimizing" },
    targeting: { frames: targetingFrames, label: "Targeting" },
    engaging: { frames: engagingFrames, label: "Engaging" },
} as const

export type AITrainingState = keyof typeof AI_TRAINING_STATES

export const AI_TRAINING_STATE_KEYS = Object.keys(AI_TRAINING_STATES) as AITrainingState[]

// Duration each state displays before rotating to next (ms)
export const AI_TRAINING_STATE_DURATION = 3000

// Duration between frame ticks within a state (ms)
export const FRAME_DURATION = 250
